<script setup>
import WorkflowsTab from "@/components/workflows/WorkflowsTab.vue";
import DocumentTemplatesTab from "@/components/workflows/DocumentTemplatesTab.vue";
import FieldTemplatesTab from "@/components/workflows/FieldTemplatesTab.vue";
import WorkflowCategoriesTab from "@/components/workflows/WorkflowCategoriesTab.vue";
import { onMounted, ref } from "vue";
import "vue3-toastify/dist/index.css";

const hasViewWorkflowsPermission = ref(false)
const hasViewDocumentTemplatesPermission = ref(false)
const hasViewFieldTemplatesPermission = ref(false)

const currentTab = ref('workflows')

onMounted(() => {
  const userData = JSON.parse(localStorage.getItem('userData'));
  const userPermissionsByRoles = userData.permissions_by_roles;
  
  const viewWorkflowsPermission = Object.values(
    userPermissionsByRoles
  ).some((permissions) => permissions.includes("View Workflows"));
  
  const viewDocumentTemplatesPermission = Object.values(
    userPermissionsByRoles
  ).some((permissions) => permissions.includes("View Document Templates"));

  const viewFieldTemplatesPermission = Object.values(
    userPermissionsByRoles
  ).some((permissions) => permissions.includes("View Field Templates"));
  
  if (viewDocumentTemplatesPermission) {
    hasViewDocumentTemplatesPermission.value = true 
  }

  if (viewWorkflowsPermission) {
    hasViewWorkflowsPermission.value = true 
  }

  if (viewFieldTemplatesPermission) {
    hasViewFieldTemplatesPermission.value = true 
  }

  if (hasViewWorkflowsPermission.value) {
    currentTab.value = 'workflows';
  } else if (hasViewDocumentTemplatesPermission.value) {
    currentTab.value = 'document-templates';
  } else if (hasViewFieldTemplatesPermission.value) {
    currentTab.value = 'field-templates';
  }
});

definePage({ meta: { requiresAuth: true } });
</script>

<template>
  <div>
    <VTabs v-model="currentTab" class="mb-1">
      <VTab v-if="hasViewWorkflowsPermission" value="workflows">Workflows</VTab>
      <VTab v-if="hasViewWorkflowsPermission" value="categories">Categories</VTab>
      <VTab v-if="hasViewDocumentTemplatesPermission" value="document-templates">Document Templates</VTab>
      <VTab v-if="hasViewFieldTemplatesPermission" value="field-templates">Field Templates</VTab>
    </VTabs>
    <VCard title="" class="">
      <VCardText class="p-0" style="padding: 0 !important">
        <VWindow v-model="currentTab">
          <VWindowItem value="workflows" v-if="hasViewWorkflowsPermission" >
            <WorkflowsTab />
          </VWindowItem>
          <VWindowItem value="categories" v-if="hasViewWorkflowsPermission" >
            <WorkflowCategoriesTab />
          </VWindowItem>
          <VWindowItem v-if="hasViewDocumentTemplatesPermission" value="document-templates" >
            <DocumentTemplatesTab />
          </VWindowItem>
          <VWindowItem v-if="hasViewFieldTemplatesPermission" value="field-templates" >
            <FieldTemplatesTab />
          </VWindowItem>
        </VWindow>
      </VCardText>
    </VCard>
  </div>
</template>
